<template>

  <div class="card green lighten-4">
    <div class="card-content">
      <h4 class="card-title" style="margin-bottom:16px">
        <span>Gruppo: {{group.name}}</span>
<!--        <button-->
<!--            class="btn"-->
<!--            @click="openModal('edit_groupData')"-->
<!--            :disabled="fields === null"-->
<!--            style="float: right"-->
<!--        >Modifica</button>-->
        <a v-if="group !== null"
           class="btn"
           :href="'index.php?option=com_asdgest&view=group&layout=edit&returnpath=dashboard&group_id='+group.group_id"
           style="float: right"
        >Vai a pagina di modifica</a>
      </h4>

      <div class="row">
        <div class="col s12 m4">
          <div class="">
            <p>Percentuale di inserimento dati obbligatori: {{perc}}%</p>
            <div class="progress">
              <div class="determinate" :style="'width:'+ perc +'%'"></div>
            </div>
          </div>
          <div v-if="missings.length > 0">
            <p>Devi ancora inserire i seguenti dati obbligatori:</p>
            <ul class="browser-default">
              <li v-for="missing of missings" :key="missing.field">{{ missing.label }}</li>
            </ul>
            <p>Fino a che questi dati non risulteranno inseriti, non potrai aggiungere le persone al tuo gruppo.</p>
          </div>
          <div v-else>
            <p>Informazioni obbligatorie inserite.</p>
          </div>

        </div>

        <div class="col s6 offset-s3 m4">
          <img :src="adaptImage(group.image_logo)" />
        </div>

        <div class="col s6 offset-s3 m4">
          <img :src="adaptImage(group.image_profile)" />
        </div>
      </div>

      <div class="modal modal-fixed-footer" id="edit_groupData" v-if="fields !== null">
        <div class="modal-content">
          <h3 class="card-title">Dati del gruppo</h3>
          <p>I campi con il bordo verde sono obbligatori per l'inserimento dei soci.</p>
          <GroupEdit :group="group" :id="id" :fields="fields" />
        </div>
        <div class="modal-footer">
          <span>Modifica i dati del gruppo:</span>
          <button class="btn red" @click="closeModal('edit_groupData')">Annulla</button>
          <button class="btn green" @click="save">
            <i v-if="saving" class="material-icons left">cloud</i>
            <span>Salva</span>
          </button>
        </div>
      </div>

    </div>
  </div>

</template>

<script>

import adaptProfileImage from './../../vue/mixins/adaptProfileImage.js';
import axios from "axios";
import Vue from 'vue';

export default {
  name: "GroupData",
  props: {
    group: {
      required: true,
      type: Object
    },
    id: {
      required: true,
      type: Number,
    },
    fields: {
      required: true,
      type: Array
    }
  },

  data: () => {
    return {
      perc: 0,
      missings: [],
      saving: false,
      editModal: null,
    }
  },

  methods: {
    calcPerc: function() {
      let count = 0;
      let filled = 0;
      for (let field of this.fields) {
        if (field.required) {
          count++;
          if (Object.prototype.hasOwnProperty.call(this.group, field.fieldname) && this.group[field.fieldname] !== '') {
            filled++;
          } else {
            this.missings.push(field);
          }
        }
      }
      this.perc = Math.floor(filled / count * 100);
      this.$emit('calculated', this.perc );
    },

    openModal: function(id) {
      let elem = document.getElementById(id);
      if (!elem) {
        console.log('Error: no element!');
        return;
      }
      this.editModal = M.Modal.init(elem);
      this.editModal.open();
    },

    closeModal: function(id) {
      let elem = document.getElementById(id);
      if (!elem) {
        console.log('Error: no element!');
        return;
      }
      const modal = M.Modal.getInstance(elem);
      modal.close();
    },

    save: function( event ) {
      this.actualSave();
    },

    makeToast( message ) {
      let html = '<span>' + message + '</span><button class="btn-flat toast-action close-toast"><i class="material-icons">close</i></button>';
      let toast = M.toast({html, displayLength: 10000});
      let els = document.querySelectorAll('.close-toast');
      els.forEach( x => {
        x.addEventListener( 'click', () => {
          toast.dismiss();
        })
      })
    },

    afterSave: function(fakeError = false) {
      console.log('Bambolized!', fakeError);
      this.saving = true;
      // TODO implement here
      window.setTimeout( () => {

        this.saving = false;
        this.closeModal('edit_groupData');

        if (!fakeError) {
          this.make('Dati del gruppo salvati');
          this.calcPerc();
        }
        else {
          this.make('Errore');
        }
      }, 2000);
    },

    adaptImage: function(image) {
      if (image === '') {
        return '/media/com_asdgest/images/placeholder/group.png';
      }
      const returned = adaptProfileImage(image);
      return returned !== '' ? returned : '/media/com_asdgest/images/placeholder/group.png';
    },

    getGroupForm: function() {
      axios.get('/index.php?option=com_asdgest&view=dashboard&layout=groupForm&format=json')
          .then( response => {
              // console.log("Group form is:", response.data)
              Vue.set(this,'fields', response.data.fields)
              this.calcPerc();
          })
    }
  },

  mounted() {
    // this.getGroupForm();
    this.calcPerc();
  }
}
</script>

<style lang="scss">
</style>
